// extracted by mini-css-extract-plugin
export default {"content":"commentary_modal_content-module__content--FGbio"};